import React from "react";

const BannerShimmer = () => {
  return (
    <div className="w-full bg-white px-4 sm:px-6 md:px-8 py-4 sm:py-6">
      {/* Banner Container */}
      <div
        className="
          relative
          w-full
          h-[60vh] sm:h-[70vh] md:h-[85vh]
          rounded-xl
          overflow-hidden
          bg-gradient-to-r
          from-gray-100
          via-gray-200
          to-gray-100
          shimmer-banner
        "
      >
        {/* Soft glow overlay */}
        <div className="absolute inset-0 bg-white/40 mix-blend-overlay" />
      </div>

      {/* Optional spacing below (for grid safety) */}
      <div className="h-16" />
    </div>
  );
};

export default BannerShimmer;
